// removed by extract-text-webpack-plugin
module.exports = {"root":"E4g9hCviHwL_bJIudokI2","progressbar-wrapper":"_22BCfPhDazsa6E_hIyOSl-","duration":"_6xxL_xHc0Qe74MDuNnUyx","current-time":"yPE2Jtjw01Vfk5XEeHPM2","playback-rate":"_17UO084QEK0qA3X-aI3VC","active":"_3RqzHYipVSu83Vvgp0Jics","volume-slider":"_2MFThUIZJZ6ZrDnUncNReM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/media-player.scss
// module id = 1491
// module chunks = 0